import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, requireChef = false, requirePermission = null }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-[#002FA7]"></div>
          <p className="mt-4 text-zinc-600">Chargement...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (requireChef && user.role !== 'chef_agence') {
    return <Navigate to="/dashboard" replace />;
  }

  // Permission check: chef bypasses, agents need the specific permission
  if (requirePermission && user.role !== 'chef_agence' && !user.autorisations?.[requirePermission]) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;